import { useState } from 'react';
import { Button, DialogFooter } from '@pocketlaw/tetris';
import { Pagination } from 'shared/domains/common-ui';
import { ProjectTable } from './ProjectTable';
import { SelectedProjects } from './SelectedProjects';
import { useProjects } from './useProjects';
import { PickerDialog } from '../PickerDialog';
import { PickerHeader } from '../PickerHeader';
export function PickProjectDialog(props) {
    const { dialogTitle, submitLabel, initialProjects = [], onClose, onSubmit } = props;
    const [selected, setSelected] = useState(initialProjects);
    const { projects, count, limit, offset, setOffset, loading, searchQuery, search, clearSearch } = useProjects();
    const handleToggle = (project) => {
        setSelected((current) => {
            const remaining = current.filter(({ id }) => id !== project.id);
            return remaining.length === current.length ? [...current, project] : remaining;
        });
    };
    const handleSubmit = () => onSubmit(selected);
    return (<PickerDialog>
      <PickerHeader title={dialogTitle} onClose={onClose} search={search} searchQuery={searchQuery} clearSearch={clearSearch}/>
      <ProjectTable projects={projects} selected={selected} loading={loading} onToggle={handleToggle}/>
      <DialogFooter description={<Pagination count={count} limit={limit} offset={offset} setOffset={setOffset} disabled={loading}/>}>
        <SelectedProjects selected={selected} onDeselect={handleToggle}/>
        <Button size="small" appearance="primary" disabled={!selected.length} onClick={handleSubmit}>
          {submitLabel}
        </Button>
      </DialogFooter>
    </PickerDialog>);
}
